import * as types from "../actions/actionTypes";
const initialState = {
  loading: true,
  inProcess: false,
  error: false,
  errorState: false,
  detail: {},
  selected: {},
  list: [],
  select_archive: {},
  newState: "",
  last_info:{}
};

const Payment = (state = initialState, action) => {
  switch (action.type) {
    case types.PETTY_CASH_DETAIL_REQUEST:
      return {
        ...state,
        detail: {},
        loading: true
      };
    case types.PETTY_CASH_DETAIL_SUCCESS:
      return {
        ...state,
        detail: action.payLoad,
        loading: false
      };
    case types.PETTY_CASH_DETAIL_FAILURE:
      return { ...state, loading: false };
    case types.PETTY_CASH_DETAIL_CLEAR:
      return { ...state, detail: {} };

    case types.PETTY_CASH_GET_REQUEST:
      return {
        ...state,
        selected: {},
        loading: true,
        error: false
      };
    case types.PETTY_CASH_GET_SUCCESS:
      return {
        ...state,
        selected: action.payLoad,
        loading: false
      };
    case types.PETTY_CASH_GET_FAILURE:
      return { ...state, loading: false, error: true };

    case types.PETTY_CASH_STORE_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASH_STORE_SUCCESS:
      return { ...state, loading: false, select_archive: {}, last_info:{} };
    case types.PETTY_CASH_STORE_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASH_UPDATE_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASH_UPDATE_SUCCESS:
      return { ...state, loading: false, select_archive: {}, last_info:{} };
    case types.PETTY_CASH_UPDATE_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASH_LIST_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASH_LIST_SUCCESS:
      return { ...state, list: action.payLoad, loading: false };
    case types.PETTY_CASH_LIST_FAILURE:
      return { ...state, loading: false };

    case types.PETTY_CASH_SELECT_ARCHIVE_UPDATE:
      return { ...state, select_archive: action.data };
    case types.PETTY_CASH_SAVE_LAST_INFO:
      return { ...state, last_info: action.data };

    case types.PETTY_CASH_UPDATE_STATE_REQUEST:
      return { ...state, inProcess: true, errorState: false, newState: "" };
    case types.PETTY_CASH_UPDATE_STATE_SUCCESS:
      return {
        ...state,
        inProcess: false,
        newState: action.payLoad.data.state
      };
    case types.PETTY_CASH_UPDATE_STATE_FAILURE:
      return { ...state, inProcess: false, errorState: true };

    case types.PETTY_CASH_REMOVE_REQUEST:
      return { ...state, loading: true };
    case types.PETTY_CASH_REMOVE_SUCCESS:
      return { ...state, loading: false };
    case types.PETTY_CASH_REMOVE_FAILURE:
      return { ...state, loading: false };

    default:
      return state;
  }
};

export default Payment;
